import React from "react";
import { WordTimestamp } from "../../types";
import { useCurrentFrame, useVideoConfig } from "remotion";

interface GridMotionCaptionsProps {
  subtitles: WordTimestamp[];
}

export const GridMotionCaptions: React.FC<GridMotionCaptionsProps> = ({ subtitles }) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const currentMs = (frame / fps) * 1000;

  // Find the index of the active word
  const activeIndex = subtitles.findIndex(
    (sub) => currentMs >= sub.startMs && currentMs <= sub.endMs
  );

  // If no word is currently active, find the closest upcoming word
  const fallbackIndex = subtitles.findIndex((sub) => sub.startMs > currentMs);
  const currentIndex = activeIndex !== -1 ? activeIndex : fallbackIndex !== -1 ? fallbackIndex : subtitles.length - 1;

  // Window captions to show only a small range of words (current, 2 before, 2 after)
  const startRange = Math.max(0, currentIndex - 2);
  const endRange = Math.min(subtitles.length, currentIndex + 3);
  const visibleWords = subtitles.slice(startRange, endRange);

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        alignItems: "center",
        gap: "16px",
        padding: "0 60px",
        height: "120px",
        overflow: "hidden",
        boxSizing: "border-box",
      }}
    >
      {visibleWords.map((sub, i) => {
        const globalWordIndex = startRange + i;
        const isActive = globalWordIndex === activeIndex;

        // Custom styling for active words
        const scale = isActive ? 1.15 : 0.95;
        const opacity = isActive ? 1 : 0.4;
        
        return (
          <span
            key={globalWordIndex}
            style={{
              fontFamily: "var(--font-title)",
              fontSize: "44px",
              fontWeight: 800,
              color: isActive ? "#bef264" : "#ffffff", // Lime green for active tech word
              opacity,
              transform: `scale(${scale})`,
              padding: isActive ? "8px 16px" : "8px 0",
              borderRadius: "4px", // Sharp tech borders
              background: isActive ? "rgba(190, 242, 100, 0.12)" : "transparent",
              border: isActive ? "1.5px solid #bef264" : "1.5px solid transparent",
              boxShadow: isActive ? "0 0 15px rgba(190, 242, 100, 0.25)" : "none",
              textShadow: isActive ? "0 0 10px rgba(190, 242, 100, 0.4)" : "none",
              display: "inline-block",
              position: "relative",
            }}
          >
            {/* Small corner decorative indicator line for active word */}
            {isActive && (
              <span
                style={{
                  position: "absolute",
                  top: "-4px",
                  left: "-4px",
                  width: "6px",
                  height: "6px",
                  borderLeft: "2px solid #ff007f",
                  borderTop: "2px solid #ff007f",
                }}
              />
            )}
            {isActive && (
              <span
                style={{
                  position: "absolute",
                  bottom: "-4px",
                  right: "-4px",
                  width: "6px",
                  height: "6px",
                  borderRight: "2px solid #ff007f",
                  borderBottom: "2px solid #ff007f",
                }}
              />
            )}
            {sub.word}
          </span>
        );
      })}
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
